<div class="filter-for-list">
  <h3 class="alarm-project-name">{{'PROJECTS_MENU_EVENT_DYN'|translate}}</h3><br clear="both" />
  <div class="event-dyn-filters">
    <div class="date-fields">

      <div class="reset-button" (click)="reset()">
        <img id="resetFilterButton" src="../../../../assets/images/wimd/reload.png">
      </div>

      <div>{{'FROM' | translate}}</div>

      <mat-form-field>
        <input matInput [matDatepicker]="startDatePicker" [formControl]="startDateControl">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <div style="padding-left: 10px">
        <ngb-timepicker [formControl]="startTimeControl" [meridian]="false"></ngb-timepicker>
      </div>

      <div class="pickerLabels">{{'TO' | translate}}</div>

      <mat-form-field>
        <input matInput [matDatepicker]="endDatePicker" [formControl]="endDateControl">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
      <div style="padding-left: 10px">
        <ngb-timepicker [formControl]="endTimeControl" [meridian]="false"></ngb-timepicker>
      </div>

      <span>{{"LOCATION" | translate}}</span>
      <mat-form-field>
        <mat-select class="filterStyle" [formControl]="selectedLocationControl">
          <mat-option *ngFor="let loc of locations" [value]="loc.id">{{loc.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select class="filterStyle" [formControl]="chartCategoryControl">
          <mat-option *ngFor="let category of chartCategories" [value]="category">{{category}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="range-field">
        <input matInput [formControl]="minCategoryLimitControl" placeholder="Min">
      </mat-form-field>
      <mat-form-field class="range-field">
        <input matInput [formControl]="mediumCategoryLimitControl" placeholder="Medium">
      </mat-form-field>
      <mat-form-field class="range-field">
        <input matInput [formControl]="maxCategoryLimitControl" placeholder="Max">
      </mat-form-field>
      <span (click)="applyDate()" class="valid-button">
        <svg xml:space="preserve" viewBox="0 0 100 100.60000000000001">
            <polygon style=""
                     points="37.316,80.48 0,43.164 17.798,25.366 37.316,44.885 82.202,0 100,17.798 37.316,80.48 "/>
        </svg>
      </span>
    </div>

  </div>
  <button type="button" (click)="getCSV()" class="btn top-list-tools">{{"EXPORT"|translate}}
  </button>
  <app-project-sub-menu></app-project-sub-menu>
  <br clear="both" /><br clear="both" />
</div>
